import { Injectable, inject } from '@angular/core';
import { IOrderElement, IOrderElementContactMap } from '@models/orders/order-element';
import { BehaviorSubject, Observable } from 'rxjs';

import { StaticDataService } from '@mavles/shared';

@Injectable({
  providedIn: 'root'
})
export class OrderElementService {
  
  public orderElements:IOrderElement[] = [];
  public orderElementContactMap: IOrderElementContactMap[] | undefined;
  private orderElementString = "";

  private orderElements$!: BehaviorSubject<IOrderElement[]>;
  private subjectElement$!: BehaviorSubject<any>;

  private staticDataService = inject(StaticDataService);

  constructor() {
    this.orderElements$ = new BehaviorSubject<IOrderElement[]>([]);
    this.subjectElement$ = new BehaviorSubject<any>([]);
    
    this.staticDataService.subscribeDataConfig().subscribe(config => {
      if (config) {
        this.setElements(config.orderElements);
        this.setElementsMap(config.orderElementContactMap);
      }
    });
  }

  getOrderElementsByContactType(contact_type_code:string):IOrderElement[]{
    const orderElementContactMap = this.orderElementContactMap?.filter(e=>e.contact_type_code === contact_type_code);
    
    if(orderElementContactMap && orderElementContactMap.length>0){
      return this.orderElements.filter(e=>orderElementContactMap?.find(m=>m.element_code === e.element_code));
    }else{
      return [];
    }
  }

  changes$():Observable<IOrderElement[]>{
    return this.orderElements$.asObservable();
  }

  elementChanges$():Observable<any>{
    return this.subjectElement$.asObservable();
  }

  set(orderElement: string) {
    this.orderElementString = orderElement;
    this.subjectElement$.next(this.orderElementString);
  }

  setElements(elements:IOrderElement[]) {
    this.orderElements = elements;
    this.orderElements$.next(elements);
  }

  setElementsMap(elementMaps:IOrderElementContactMap[]){
    this.orderElementContactMap = elementMaps;
  }

  getCurrentElementString(): string{
    return this.orderElementString;
  }

  getCurrentElementContactType():string | undefined{
    return this.getCurrentElement()?.contact_types.map(c=>c.contact_type_code)[0];
  }

  getCurrentElement():IOrderElement | undefined{
    return  this.orderElements.find(o=>o.element_local_code==this.orderElementString);
  }

  getCurrentElementID():number | undefined{
    return  this.orderElements.find(o=>o.element_local_code==this.orderElementString)?.element_id;
  }

  getElementByCode(element_local_code:string):IOrderElement | undefined{
    return  this.orderElements.find(o=>o.element_local_code==element_local_code);
  }
  
  getElementByContactType(contact_type_id:number | undefined):IOrderElement{
    let orderElemnt!:IOrderElement;
    this.orderElements.forEach(e=>{
      e.contact_types.forEach(c=>{
        if(c.contact_type_id === contact_type_id){
          orderElemnt = e;
        }
      });
    });
    return orderElemnt;
  }

  getCurrElement():Promise<IOrderElement|undefined>{
    return new Promise((resolve, reject) => {
       if(this.orderElements.length>0){
          resolve(this.orderElements.find(o=>o.element_local_code==this.orderElementString));
       }else{
        const sub$ =this.changes$();
        sub$.subscribe(res=>{
          if(res.length>0){
            resolve(this.orderElements.find(o=>o.element_local_code==this.orderElementString));
          }
        });
       }
    });
  }

  get isEstimateElement():boolean{
    return this.orderElementString === "estimate";
  }
}
